/* eslint-disable no-empty */
import { BasketballUserProfile } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const basketballUserApi = createApi({
  reducerPath: 'basketballUserApi',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchProfile: builder.query<BasketballUserProfile, number>({
      query: (id) => `v2/basketball/users/${id}/profile`,
    }),
  }),
});

// Export hooks for usage in functional components
export const { reducerPath, reducer, middleware, useFetchProfileQuery } =
  basketballUserApi;
